module.exports = __webpack_public_path__ + "static/media/add-file.3cb10189.svg";